import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import React, { useState } from 'react';
import { useUpdatePassword } from '../../../hooks/useUpdatePassword';
import { useAuth } from '../../../context/AuthContext';

const SecurityTab = () => {

    const { mutate: updatePasswordMutate, isLoading } = useUpdatePassword();
    const { user } = useAuth();

    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [confirmNewPasswordError, setConfirmNewPasswordError] = useState('');

    const handleSubmitForm = (e) => {
        e.preventDefault();
        setConfirmNewPasswordError('');
        
        if (!oldPassword) {
            setConfirmNewPasswordError('Veuillez entrer votre mot de passe actuel.');
            return;
        }
        
        if (newPassword !== confirmNewPassword) {
            setConfirmNewPasswordError('Les mots de passe ne correspondent pas.');
            return;
        }
        
        // Politique de mot de passe : 12 caractères min, 1 maj, 1 min, 1 chiffre, 1 caractère spécial
        if (newPassword.length < 12) {
            setConfirmNewPasswordError('Le mot de passe doit contenir au moins 12 caractères.');
            return;
        }
        
        if (!/[A-Z]/.test(newPassword)) {
            setConfirmNewPasswordError('Le mot de passe doit contenir au moins une lettre majuscule.');
            return;
        }
        
        if (!/[a-z]/.test(newPassword)) {
            setConfirmNewPasswordError('Le mot de passe doit contenir au moins une lettre minuscule.');
            return;
        }
        
        if (!/[0-9]/.test(newPassword)) {
            setConfirmNewPasswordError('Le mot de passe doit contenir au moins un chiffre.');
            return;
        }
        
        if (!/[!@#$%^&*()_+=\-[\]{};':"\\|,.<>/?]/.test(newPassword)) {
            setConfirmNewPasswordError('Le mot de passe doit contenir au moins un caractère spécial.');
            return;
        }
        
        updatePasswordMutate({ oldPassword, newPassword, userId: user?.data?.id });
        
        // Réinitialiser les champs après soumission
        setOldPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
    }


    return (
        <Row className='ml-3'>
            <Col xl={12} >
                <Form onSubmit={handleSubmitForm}>
                    <Card>
                        <Card.Header className="py-2 d-flex" >
                            <Card.Title>
                                <span className='text-body text-s m-0 p-0'>Changer votre mot de passe</span>
                            </Card.Title>
                        </Card.Header>
                        <Card.Body className=''>
                            <Form.Group controlId='idMdpActuel' className='mb-3'>
                                <Form.Label className='text-body text-sm'>Mot de passe actuel</Form.Label>
                                <Form.Control 
                                    type="password" 
                                    placeholder="Entrez votre mot de passe actuel"
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                    required
                                    className="before-input"
                                />
                            </Form.Group>
                            <Form.Group controlId='idNouveauMdp' className='mb-3'>
                                <Form.Label className='text-body text-sm'>Nouveau mot de passe</Form.Label>
                                <Form.Control 
                                    type="password" 
                                    placeholder="Entrez votre nouveau mot de passe"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                    required
                                    minLength={12}
                                    className="before-input"
                                />
                                <Form.Text className="text-muted small fst-italic">
                                    Le mot de passe doit contenir au moins 12 caractères, une majuscule, une minuscule, un chiffre et un caractère spécial.
                                </Form.Text>
                            </Form.Group>
                            <Form.Group controlId='idConfirmMdp' className='mb-3'>
                                <Form.Label className='text-body text-sm'>Confirmer votre nouveau mot de passe</Form.Label>
                                <Form.Control 
                                    type="password" 
                                    placeholder="Confirmer votre nouveau mot de passe"
                                    value={confirmNewPassword}
                                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                                    isInvalid={!!confirmNewPasswordError}
                                    required
                                    className="before-input"
                                />
                                <Form.Control.Feedback type="invalid">
                                    {confirmNewPasswordError}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Button variant="primary" type="submit" disabled={isLoading}>
                                {isLoading ? 'Modification en cours...' : 'Modifier le mot de passe'}
                            </Button>
                        </Card.Body>
                    </Card>
                </Form>
            </Col>
        </Row>
    );
};

export default SecurityTab;